import { css, useTheme } from "@emotion/react"
import React from "react"
import { BodyTextRegular } from "../typography/text"

type Props = {
  children: React.ReactNode
  disabledState?: boolean
  disabledBackgroundColor?: string
}

export const CartSizeIndicator = ({
  children,
  disabledState,
  disabledBackgroundColor,
}: Props) => {
  const theme = useTheme()
  const cartSizeIndicatorStyle = css`
    width: 24px;
    height: 24px;
    border-radius: 40px;
    justify-content: center;
    align-items: center;
    display: flex;
    background: ${disabledState
      ? disabledBackgroundColor || theme.colors.secondary2
      : theme.colors.ctaSecondaryTwo};
  `
  return (
    <div css={cartSizeIndicatorStyle}>
      <BodyTextRegular color={theme.colors.white}>{children}</BodyTextRegular>
    </div>
  )
}
